var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm-hint-wrap",on:{"mouseenter":_vm.enter,"mouseleave":_vm.leave}},[_vm._t("content"),(_vm.showHint)?_c('hint-block',{class:{
      'left': _vm.left,
      'horizontal': _vm.horizontal
    }},[_c('template',{slot:"hintContent"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}})])],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }